import { useNavigate } from "react-router-dom";
import { useAuthDispatch, LOGOUT } from "../../context/AuthContext";
import { logout } from "../../lib/api/auth";
import LogoutForm from "../../components/auth/LogoutForm";

const Logout = () => {
  const navigate = useNavigate();
  const authDispatch = useAuthDispatch();

  const onClickYes = async () => {
    try {
      await logout();
      // authDispatch({
      //   type: LOGOUT,
      // });
      // navigate("/", { replace: true });
    } catch (error) {
      console.log(error);
      navigate("/");
    }
  };

  const onClickNo = () => {
    navigate(-1);
  };

  return (
    <LogoutForm
      onClickYes={onClickYes} //
      onClickNo={onClickNo}
    />
  );
};

export default Logout;
